<form [formGroup]="definitionForm" (ngSubmit)="onSave()">
    <div class="definition-main-container">
        <div class="definition-instructions-container">
            <r1-compass-lib-instructions headerText="Definition"
                >Provide a name and description for the Lifecycle Rule for reference later.
            </r1-compass-lib-instructions>
        </div>
        <div class="definition-fields-container">
            <div class="form-row-container">
                <span class="field-row-name">Lifecycle Rule Internal Name *</span>
                <mat-form-field class="field-wrapper">
                    <mat-label>Lifecycle Rule Name</mat-label>
                    <input matInput type="text" [formControl]="definitionForm.controls.name" />
                    @if (definitionForm.controls.name.hasError('required')) {
                        <mat-error>Field is required</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-row-container">
                <span class="field-row-name">Lifecycle Rule Internal Description</span>
                <mat-form-field class="field-wrapper">
                    <mat-label>Lifecycle Rule Description</mat-label>
                    <textarea
                        id="descriptionTextArea"
                        matInput
                        rows="3"
                        [formControl]="definitionForm.controls.description"></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="footer-container">
        <button mat-raised-button color="primary" [disabled]="disableSave()" type="submit">Save</button>
    </div>
</form>
